import React, { Component } from 'react';
import './../index.css';
import apiurl from '../apiurl';
import axios from 'axios';
import swal from 'sweetalert';
import Select from 'react-select';
import NumberFormat from 'react-number-format';

export default class ZadaniaWydzialoweDodaj extends React.Component {
constructor(props) {
  super(props);    
  this.state = {
    data: [],
    idZadWydz: null,
    kwota: 0,
  }

}

componentDidMount() {
  this.getdata();
}

getdata = () => {
  let idw = this.props.idw;

  if(idw === '-1') {
    axios
      .get(apiurl+"api/ZadWydz/all",{ params: { rok : this.props.rok }, headers: { 'Authorization' : "Bearer " + this.props.token }})
      .then(response => {
        let data1 = response.data.map( category => ({ value: category.kodJedn, label: category.nazwa}));
        this.setState({ data: data1 });
      })
      .catch(error => swal(error.response.data.messege) );
  } else {
    axios
      .get(apiurl+"api/ZadWydz",{ params: { rok : this.props.rok, idWydz: idw }, headers: { 'Authorization' : "Bearer " + this.props.token }})
      .then(response => {
        let data1 = response.data.map( category => ({ value: category.kodJedn, label: category.nazwa}));
        this.setState({ data: data1 });
      })
      .catch(error => swal(error.response.data.messege) );
  }
}

saveData = (e)  => {
  e.preventDefault();

  let userData = this.props.user;
  axios.post(apiurl+"api/ZadWydzPlan", {
        idZadWydz: this.state.idZadWydz,
        rok: this.props.rok,
        dzial: userData.Dzial,
        rozdzial: userData.Rozdzial,
        paragraf: userData.Paragraf + userData.P4, 
        pozycja: userData.Pozycja,
        dw: userData.DW,
        bp: userData.BP,
        wzp: userData.idRodzaju,
        kwota: this.state.kwota,
    }, {headers : {'Content-Type': 'application/json' , 'Authorization' : "Bearer " + this.props.token } })
      .then(res => {
        console.log(res.data)
      })
  .catch(error => swal(error.response.data));
}


changeKwota = (e) => { this.setState({ kwota: e.target.value }) }


render() {
  let { data } = this.state;
  return (<>
    <div className='d-flex container p-3'>
      <form className='d-flex flex-column ' onSubmit={(e) => (this.saveData(e))}>
        <div class="mb-3">
          <label for="wybWydz" class="form-label">Wydział</label>
          <Select name="form-field-name mt-2" options={data} id='wybWydz' onChange={v => this.setState({ idZadWydz: v.value })} required />
        </div>

        <div class="mb-3">
          <label for="kwota" class="form-label">Kwota</label>
          <NumberFormat value={this.state.kwota} class="form-control mt-2" id='kwota' onChange={(e) => (this.changeKwota(e))} fixedDecimalScale={true} decimalScale={2} decimalSeparator={','} required/>
        </div>
        <div className='d-flex flex-row'>
          <button className='btn btn-light mt-2' onClick={() => (this.props.closeDodaj())} >Wróc</button>
          <button className='btn btn-light mt-2' type="submit" >Zapisz</button>
        </div>


      </form>

    </div>
  </>);
}
}


